import { MutableRefObject, useRef } from "react";

// The actual type is way to complex to pass around,
// with several levels of generics.
interface RTKQueryMutationSubscription {
  abort: () => void;
  reset: () => void;
}

type UseMutationSubscriptionRefReturn = MutableRefObject<
  RTKQueryMutationSubscription | undefined
>;
export function useMutationSubscriptionRef(): UseMutationSubscriptionRefReturn {
  return useRef<RTKQueryMutationSubscription>();
}
